// extracted by mini-css-extract-plugin
export default {"root":"IconSocialMediaX_root__7Htzr"};